// extracted by mini-css-extract-plugin
export default {"container":"yX-z","title":"zX-z","link":"AX-z"};